<div
  class="filter-overlay"
  [class.visible]="visible"
  (click)="close.emit()"
></div>

<div class="filter-drawer" [class.open]="visible">
  <div class="fd-header">
    <div class="fd-title">
      <i class="ri-equalizer-3-line"></i> Filtros de Equipamentos
    </div>
    <button type="button" class="btn-icon" (click)="close.emit()">
      <i class="ri-close-line"></i>
    </button>
  </div>

  <div class="fd-body" [formGroup]="filtrosForm">
    <!-- Pesquisa -->
    <div class="fd-section">
      <div class="sp-form-group">
        <label>
          <i class="ri-search-line"></i> Código Interno / Matrícula / Nome
        </label>
        <input
          type="text"
          pInputText
          class="sp-input w-full"
          formControlName="Search"
          placeholder="Ex: LD-45-89-AB"
        />
      </div>
    </div>

    <div class="fd-section">
      <div
        class="fd-grid-props"
        style="display: flex; flex-direction: column; gap: 9px"
      >
        <!-- Campo Pai: Tipo de Equipamento -->
        <div class="sp-form-group">
          <label>Tipo de Equipamento</label>
          <p-select
            formControlName="IdTipoEquipamento"
            [options]="tipoOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione um tipo..."
            [showClear]="true"
            styleClass="w-full"
            appendTo="body"
          />
        </div>

        <!-- Campo Filho: Categoria de Equipamento (Dependente) -->
        <div class="sp-form-group">
          <label>Categoria de Equipamento</label>
          <p-select
            formControlName="TipoEquipamentoEnum"
            [options]="tiposEquipamentoEnum"
            optionLabel="label"
            optionValue="value"
            [placeholder]="!filtrosForm.get('IdTipoEquipamento')?.value ? 'Selecione primeiro o Tipo...' : 'Selecione a categoria...'"
            [showClear]="true"
            [filter]="true"
            filterBy="label"
            styleClass="w-full"
            appendTo="body"
          />
          <small
            class="fd-hint"
            *ngIf="filtrosForm.get('IdTipoEquipamento')?.value && tiposEquipamentoEnum.length === 0"
          >
            Não existem categorias disponíveis para o Tipo selecionado.
          </small>
        </div>
      </div>
    </div>

    <!-- Estado e Disponibilidade -->
    <div class="fd-section">
      <p class="fd-section-title">Estado e Disponibilidade</p>
      <div
        class="fd-grid-props"
        style="display: flex; flex-direction: column; gap: 9px"
      >
        <div class="sp-form-group">
          <p-select
            formControlName="Estado"
            [options]="estadoOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Todos os estados"
            [showClear]="true"
            styleClass="w-full"
            appendTo="body"
          />
        </div>

        <div class="sp-form-group">
          <label>Activo no Sistema</label>
          <p-select
            formControlName="Ativo"
            [options]="ativoOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Todos"
            styleClass="w-full"
            appendTo="body"
          />
        </div>
      </div>
    </div>

    <div class="fd-section">
      <div class="sp-form-group">
        <label>Posto</label>
        <p-select
          formControlName="IdPosto"
          [options]="postoOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos os postos"
          [showClear]="true"
          [filter]="true"
          filterBy="label"
          styleClass="w-full"
          appendTo="body"
        />
      </div>
    </div>

    <div class="fd-section">
      <div class="sp-form-group">
        <label>Data</label>
        <p-datepicker
          formControlName="DataAquisicao"
          dateFormat="yy-mm-dd"
          placeholder="AAAA-MM-DD"
          [showIcon]="true"
          [showButtonBar]="true"
          [autoZIndex]="true"
          [baseZIndex]="1100"
          panelStyleClass="drawer-datepicker-panel"
          styleClass="w-full"
          appendTo="body"
        />
      </div>
    </div>
  </div>

  <div class="fd-footer">
    <button type="button" class="btn-secondary-action" style="flex: 1" (click)="clearFilters()">
      <i class="fas fa-undo"></i> Limpar
    </button>
    <button type="button" class="btn-primary" style="flex: 1.7" (click)="applyFilters()">
      <i class="fas fa-check"></i> Aplicar
    </button>
  </div>
</div>
